<template>
  <div>
    <v-dialog v-model="assetFormVueDialog" persistent max-width="500" scrollable>
      <v-card v-if="assetFormVueDialog">
        <v-card-title class="info white--text justify-between">
          {{
          isCreate
          ? text.isCreate + text.title
          : isUpdate
          ? text.isUpdate + text.title
          : "-"
          }}
          <v-btn color="white" icon @click="assetFormVueDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5">
          <!-- Content Space -->
          <v-form ref="form">
            <label>{{ $t('accounting_product.list_name') }}</label>
            <v-text-field
              :label="$t('accounting_product.list_name')"
              v-model="form.name"
              :rules="[(v) => !!v || $t('validate.please_enter_list_name')]"
              flat
              solo
              background-color="grey lighten-4"
            ></v-text-field>
            <label>{{ $t('product.list_name_en') }}</label>
            <v-text-field
              :label="$t('product.list_name_en')"
              v-model="form.name_en"
              flat
              solo
              background-color="grey lighten-4"
            ></v-text-field>
            <label>{{ $t('category') }}</label>
            <v-autocomplete
              :items="assetCategories"
              item-value="id"
              :item-text="(r) => `${r.name} - ${r.name_en}`"
              flat
              solo
              :rules="[(v) => !!v || this.$t('validate.please_select_category')]"
              background-color="grey lighten-4"
              append-outer-icon="mdi-plus"
              v-model="form.assetCategoryId"
              @click:append-outer="showAssetCategory(true, false)"
            >
              <template v-slot:item="{ item }">
                <div class="flex justify-between items-center w-full">
                  {{ item.name }} - {{ item.name_en }}
                  <v-btn color="warning" icon @click="showAssetCategory(false, true, item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-slot:
            </v-autocomplete>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="onCancel">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="onSave"
            :disabled="isDisable || isLoading"
            :loading="isLoading"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <asset-category-form
      v-model="isCategory"
      @onSave="getAssetCategories"
      :isCreate="category.isCreate"
      :isUpdate="category.isUpdate"
      :object="category.object"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AssetCategoryForm from "./AssetCategoryForm.vue";
export default {
  components: { AssetCategoryForm },
  name: "AssetFormVue",
  computed: {
    ...mapGetters({
      assetCategories: "assetCategory/getAssetCategories"
    }),
    assetFormVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    }
  },
  data() {
    return {
      form: {
        name: "",
        name_en: "",
        assetCategoryId: ""
      },
      text: {},
      isCategory: false,
      isLoading: false,
      category: {
        isCreate: false,
        isUpdate: false,
        object: {}
      }
    };
  },
  props: {
    value: Boolean,
    object: Object,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean
  },
  created() {
    this.text = {
      title: this.$t('asset.asset_list'),
      isCreate: this.$t('action_type.add'),
      isUpdate: this.$t('action_type.edit')
    };
  },
  methods: {
    async initData() {
      try {
        const params = {};
        if (this.isCreate) {
          this.resetForm();
        } else {
          this.form = {
            ...this.object
          };
        }
        await this.getAssetCategories();
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        const params = this.form;
        if (this.isCreate) {
          const response = await this.$store.dispatch("asset/createAsset", {
            ...params,
            projectId: this.$route.params.projectId
          });
          return response;
        } else {
          const response = await this.$store.dispatch("asset/updateAsset", {
            ...params
          });
          return response;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async onSave() {
      try {
        this.isLoading = true;
        if (this.$refs.form.validate()) {
          const response = await this.saveData();
          this.assetFormVueDialog = false;
          this.$emit("onSave", response);
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.assetFormVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
    async getAssetCategories() {
      try {
        const response = await this.$store.dispatch(
          "assetCategory/getAssetCategories",
          { projectId: this.$route.params.projectId }
        );
        return response;
      } catch (e) {
        console.log(e);
      }
    },
    showAssetCategory(isCreate, isUpdate, object = {}) {
      this.category.isCreate = isCreate;
      this.category.isUpdate = isUpdate;
      this.category.object = object;
      this.isCategory = true;
    },
    resetForm() {
      try {
        this.form = {
          name: "",
          name_en: "",
          assetCategoryId: ""
        };
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
